import axios from "axios";
import { PLANNER_BASE_URL } from "../constants";

const api = axios.create({
  baseURL: PLANNER_BASE_URL,
  timeout: 10000, // 10 segundos
});

export const busApi = {
  /**
   * Geocode: converte endereço em coordenadas
   */
  geocode: (address) =>
    api.get("/api/planner/geocode", { params: { address } }),

  /**
   * Plan Route: calcula itinerários
   */
  planRoute: (params) => api.get("/api/planner/plan-route", { params }),

  /**
   * Get Routes: lista linhas de ônibus
   */
  getRoutes: (search) =>
    api.get("/api/planner/routes", {
      params: search ? { search } : undefined,
    }),

  /**
   * Get Route Departures: horários de uma linha
   */
  getDeparturesByRoute: (routeId) =>
    api.get(`/api/planner/routes/${routeId}/departures`),

  /**
   * Get Stop Departures: próximos ônibus em uma parada
   */
  getStopDepartures: (stopId) =>
    api.get(`/api/planner/stops/${stopId}/departures`),

  /**
   * Get Nearby Stops: paradas próximas de uma coordenada
   * @param {Object} params
   * @param {number} params.lat
   * @param {number} params.lng
   * @param {number} [params.radius]
   * @param {number} [params.limit]
   */
  getNearbyStops: (params) => api.get("/api/planner/stops/nearby", { params }),

  /**
   * Get Trip Shape: percurso completo + (opcional) paradas por tripId
   * @param {string} tripId
   * @param {Object} [options]
   * @param {boolean} [options.includeStops]
   */
  getTripShape: (tripId, options = {}) =>
    api.get(`/api/planner/trips/${encodeURIComponent(tripId)}/shape`, {
      params: options,
    }),

  /**
   * Get Vehicle Positions: posições em tempo real dos ônibus
   * @param {Object} filters - Filtros opcionais
   * @param {string} filters.routeId - ID de uma linha
   * @param {string} filters.routeIds - IDs de múltiplas linhas (separado por vírgula)
   * @param {string|number} filters.directionId - Sentido ("0"/"1" ou 0/1)
   * @param {string} filters.bounds - Bounding box (minLat,minLng,maxLat,maxLng)
   * @param {number} filters.limit - Limite de veículos
   */
  getVehiclePositions: (filters = {}) =>
    api.get("/api/planner/vehicle-positions", { params: filters }),
};

export default busApi;
